<div class="mgo-location-search">
  <!-- <form (ngSubmit)="searchLocation()">
      <ng-container #findLocation ></ng-container>
        <span *ngIf="flow === 'deposit' && isSdfCardFlow" class="search-address-label">{{ labels.selectPaymentLocation }}</span>
        <span *ngIf="flow === 'deposit' && !isSdfCardFlow" class="search-address-label">{{ labels.findPaymentLocation }}</span>
        <span *ngIf="flow === 'withdraw'" class="search-address-label">{{ labels.findCashoutLocation }}</span>
      <form>
        <mat-form-field appearance="standard">
          <input tabindex="0" #refSearchKeyword matInput [formControl]="searchKeywordControl" id="searchKeyword" [placeholder]="labels.searchHelpText">
          <mat-icon aria-hidden="false" aria-label="search" matPreffix [ngClass]="{'disable': !this.searchKeywordControl.value}" (click)="searchLocation()">search</mat-icon>
        </mat-form-field>
        <div id="autocompleteSuggestions"></div>
      </form>
    </form> -->

  <!-- <form class="search-form" (ngSubmit)="searchLocation()">
    <span
      *ngIf="flow === 'deposit' && isSdfCardFlow"
      class="search-address-label"
      >{{ labels.stellar.location.selectPaymentLocation }}</span
    >
    <span
      *ngIf="flow === 'deposit' && !isSdfCardFlow"
      class="search-address-label"
      >{{ labels.stellar.location.findPaymentLocation }}</span
    >
    <span *ngIf="flow === 'withdraw'" class="search-address-label">{{
      labels.stellar.sdfcard.locationMaps.findLocationNearby
    }}</span>
    <div class="search-container">
      <div class="search-icon-input">
        <img
          tabindex="0"
          aria-hidden="false"
          aria-label="search"
          matPreffix
          (click)="searchLocation()"
          src="assets\images\form-iOS-search-filled.svg"
          alt="search-filled"
          [ngClass]="{ disable: !searchKeywordControl.value }"
        />
        <div class="input-container">
          <input
            #refSearchKeyword
            tabindex="1"
            type="text"
            [formControl]="searchKeywordControl"
            id="searchKeyword"
            [placeholder]="placeHolderSearch()"
            (keydown.enter)="searchLocation()"
            (input)="onChangeSearch()"
            (focus)="onFocusSearch($event)"
            (blur)="handleBlurSearchLocation()"
            autofocus="false"
          />
        </div>
      </div>
      <img
        src="assets\images\remove-circle.svg"
        alt="remove-icon"
        [ngClass]="{ visible: !searchKeywordControl.value }"
        (click)="handleClickRemoveInputTextSearchLoc(searchKeywordControl)"
      />
    </div>
  </form> -->

  <!-- <mat-chip-listbox class="chip-list-box">
    <mat-chip-option class="chip-option" [ngClass]="isSelected(option) ? 'chip-option-selected' : 'chip-option-unselected'" 
      *ngFor="let option of sortOptions" 
      [selected]="isSelected(option)"
      (click)="toggleSelection(option)">
      <span>{{option}}</span>
      <mat-icon class="chip-icon" *ngIf="isSelected(option)">done</mat-icon>
    </mat-chip-option>
  </mat-chip-listbox> -->

<!-- 
  <section
    class="cont-autocomplete-list"
    [ngClass]="{ 'hide-autocomplete-list': !showAutocompleteList }"
  >
    <ul
      #refUlPredictions
      *ngIf="!searchError && arrayAutocompleteList.length !== 0"
    >
      <li
        *ngFor="let autocompleteOption of arrayAutocompleteList"
        (click)="onclickLiAddressPredicted(autocompleteOption.description)"
        [ngClass]="{
          active:
            autocompleteOption.description === searchKeywordControl.value
              ? true
              : false
        }"
      >
        <div class="row-li">
          <div class="li-address">
            <b>{{ autocompleteOption.boldSection }}</b>
            {{ autocompleteOption.continued }}
          </div>
          <img
            src="assets\images\checked-circle.svg"
            class="check"
            *ngIf="
              autocompleteOption.description === searchKeywordControl.value
            "
          />
        </div>
      </li>
    </ul>
    <section
      *ngIf="searchError || arrayAutocompleteList.length === 0"
      class="error-search"
    >
      <div class="error-no-results" *ngIf="searchError && !isMobileSize">
        <img class="info" src="assets\images\map-location\circle-info.svg" />
        <div>{{ locationLabels?.noLocationAvailable }}</div>
      </div>
      <div class="error-no-results" *ngIf="!searchError">
        <img class="info" src="assets\images\map-location\circle-alert.svg" />
        <div>{{ sdfCardLabels.locationMaps.notification.searchNoResult }}</div>
      </div>
    </section>
  </section> -->
  <div class="search-form-container">
    <div class="header-container">
      <div class="header-label">
        <ng-container
        *ngIf="flow === 'deposit' && isSdfCardFlow"
        class="search-address-label"
        >{{ handleFormatString(labels.stellar.location.selectPaymentLocation) }}</ng-container
      >
      <ng-container *ngIf="flow === 'withdraw' && isSdfCardFlow" class="search-address-label">{{
        labels.stellar.sdfcard.locationMaps.findLocationNearby
      }}</ng-container>
      </div>
    </div>
    <div class="parent-search-form-wrapper">
      <div class="search-form">
        <div class="search-icon">
          <img
          tabindex="0"
          aria-hidden="false"
          aria-label="search"
          matPreffix
          (click)="handleBasicSearch()"
          src="assets\images\form-iOS-search-filled.svg"
          alt="search-filled"
          [ngClass]="{ disable: !searchKeywordControl.value }"
        />
        </div>
        <div class="input-field">
          <input type="text"  
          #refSearchKeyword
          tabindex="1"
          type="text"
          [formControl]="searchKeywordControl"
          id="searchKeyword"
          [placeholder]="placeHolderSearch()"
          (keydown.enter)="handleBasicSearch()"
          (input)="onChangeSearch()"
          (focus)="onFocusSearch($event)"
          (blur)="handleBlurSearchLocation()"
          autofocus="false">
        </div>
        <div class="remove-icon" *ngIf="searchKeywordControl?.value">
          <img
          src="assets\images\remove-circle.svg"
          alt="remove-icon"
          (click)="handleClickRemoveInputTextSearchLoc(searchKeywordControl)"
        />
        </div>
      </div>
      <div class="close-dailog--container">
        <img
        (click)="Onclose()"
        src="assets\images\close-black-icon.svg"
        alt="close-icon"
        class="close-button"
      />
      </div>
    </div>
    <div class="sort-container">
      <ng-container   *ngFor="let option of sortOptions">
        <div class="optionItem"  (click)="toggleSelection(option)" [ngClass]="isSelected(option) ? 'option-selected' : 'option-unselected'">
            <div class="option-label">
                {{ option }}
            </div>
            <img  *ngIf="isSelected(option)" src="assets\images\map-location\checkMark.svg" alt="check mark">
            <!-- <div class="img-placeholder" *ngIf="!isSelected(option)"></div> -->
        </div>
      </ng-container>
    </div>
  </div>
  <section
    class="cont-autocomplete-list"
    [ngClass]="{ 'hide-autocomplete-list': !showAutocompleteList }"
  >
    <ul
      #refUlPredictions
      *ngIf="!searchError && arrayAutocompleteList.length !== 0"
    >
      <li
        *ngFor="let autocompleteOption of arrayAutocompleteList"
        (click)="onclickLiAddressPredicted(autocompleteOption.description)"
        [ngClass]="{
          active:
            autocompleteOption.description === searchKeywordControl.value
              ? true
              : false
        }"
      >
        <div class="row-li">
          <div class="li-address">
            <b>{{ autocompleteOption.boldSection }}</b>
            {{ autocompleteOption.continued }}
          </div>
          <img
            src="assets\images\checked-circle.svg"
            class="check"
            *ngIf="
              autocompleteOption.description === searchKeywordControl.value
            "
          />
        </div>
      </li>
    </ul>
    <section
      *ngIf="searchError || arrayAutocompleteList.length === 0"
      class="error-search"
    >
      <div class="error-no-results" *ngIf="searchError && !isMobileSize">
        <img class="info" src="assets\images\map-location\circle-info.svg" />
        <div>{{ locationLabels?.noLocationAvailable }}</div>
      </div>
      <div class="error-no-results" *ngIf="!searchError">
        <img class="info" src="assets\images\map-location\circle-alert.svg" />
        <div>{{ sdfCardLabels.locationMaps.notification.searchNoResult }}</div>
      </div>
    </section>
  </section>
</div>
